import React from "react";

        // key={i}
        // tag={tag}
        // classNames={this.state.classNames}
        // onDelete={this.handleDeleteTag.bind(this, i)}

function CFPSTag ({tag, classNames, onDelete}) {
  classNames = classNames.selectedTag
  if(tag.error){
    classNames += " error";
  }
  return (
    <button type='button' className={classNames} title='Click to remove tag' onClick={onDelete}>
      <span className={classNames.selectedTagName}>{tag.name}</span>
    </button>
  )
};

export default CFPSTag;